import React from 'react';

import { Intent, Spinner, SpinnerSize } from '@blueprintjs/core';

import { SpinnerContainer, MessageContainer, Message } from './styles';

interface LoadingProps {
  message?: string;
}

const Loading = ({ message }: LoadingProps) => {
  return (
    <SpinnerContainer>
      <Spinner intent={Intent.PRIMARY} size={SpinnerSize.LARGE} />
      {message && (
        <MessageContainer>
          <Message>{message}</Message>
        </MessageContainer>
      )}
    </SpinnerContainer>
  );
};

export default Loading;
